import SD from 'components/SearchDropdown'
import createWrappedField from './createWrappedField'

export default createWrappedField({
  Component: SD,
  name: 'DDISearchDropdown'
})
